<template>
  <div class="nav-wrapper">
    <TopBanner />
    <div class="nav-inline-wrapper">
      <div class="header-logo">
        <a :href="navData?.logoLink">
          <img :src="navData?.logoImg">
        </a>
        <div class="container" :class="{ change: isChanged }" @click="toggleMenu">
          <hamburger-button
            theme="outline"
            size="24"
            fill="#fff"
            class="icon"
            :class="[!isChanged?'':'hidden']"
          />
          <close-small
            theme="outline"
            size="24"
            fill="#fff"
            class="icon"
            :class="[isChanged?'':'hidden']"
          />
        </div>
      </div>
      <div class="header-menu">
        <div class="header-menu-box" :class="[isChanged?'show-menu':'hidden-menu']">
          <n-button
            v-for="item in navData.menus"
            :key="item"
            class="header-menu-content"
            text
            tag="a"
            :href="getMenuLink(item)"
            :target="item.blank ? '_blank' : null"
            type="info"
          >
            <n-dropdown trigger="hover" style="border-radius: 10px;margin-top: 25px" :options="item.options">
              {{ item.label }}
            </n-dropdown>
            <n-badge v-if="item.new" value="新" color="red" />
          </n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="NavigationBar">
import { ref, computed } from 'vue'
import TopBanner from './TopBanner.vue'
import { HamburgerButton, CloseSmall } from '@icon-park/vue-next'
import type { NavsType } from '~/types/home/navs'

const isChanged = ref(false)
const toggleMenu = () => {
  isChanged.value = !isChanged.value
}

const props = defineProps<{
  navData: NavsType
}>()
const getMenuLink = (item:any) => {
  if (item.linkType === 2) {
    return '#pricing-section'
  } else {
    return item.link
  }
}
const navData = computed(() => props.navData)
</script>
<style scoped lang="scss">
@media (max-width: 767px) {

  .nav-inline-wrapper {
    padding: 15px 0 !important;
    flex-direction: column;
    max-width: 100%!important;
    align-items: flex-start !important;
  }

  .header-logo {
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    width: 100vw;
  }
  .hidden-menu {
    display: none !important;
  }

  .container {
    display: block !important;
  }
  .header-menu-box {
    display: flex;
    flex-direction: column;
  }
  .header-menu {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #000000;
  }
  .header-menu-content:hover {
    color: #fff !important;
    border: none !important;
    background-color: #1890ff;
  }
}

.container {
  display: none;
  cursor: pointer;
}

.show-menu {
  display: flex;
}

.header-menu-content {
  float: left;
  display: block;
  color: #f2f2f2;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700 !important;
}

.header-menu-content:hover {
  color: #1890ff;
  border-bottom: 2px solid #1890ff;
}

.icon {
  display: flex;
  position: relative;
  transition: transform .3s cubic-bezier(.645, .045, .355, 1), opacity .3s cubic-bezier(.645, .045, .355, 1);;
}

.hidden {
  position: absolute;
  top: -200;
  visibility: hidden;
  pointer-events: none; /* 隐藏时不响应点击事件 */
}

.nav-wrapper {
  position: fixed;
  top: 0;
  background-color: #000;
  width: 100%;
  z-index: 1000;
}

.nav-inline-wrapper {
  height: 65px;
  width: 100%;
  margin: auto;
  will-change: transform;
  color: #b3c0d1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 80px;

  .header-logo {
    img {
      width: 90px;
    }
  }
}
</style>
